export const copyToClipboard = (containerId) => {
    const element = document.getElementById(containerId);
    if (element) {
        const text = element.innerText || element.textContent;
        navigator.clipboard.writeText(text).then(() => {
            console.log('Content successfully copied to clipboard');
        }).catch(err => {
            console.error('Failed to copy content: ', err);
        });
    }
    else {
        console.error('Element not found: ', containerId);
    }
};
export const copyTextToClipboard = (text) => {
    navigator.clipboard.writeText(text).then(() => {
        console.log('Text successfully copied to clipboard');
    }).catch(err => {
        console.error('Failed to copy text: ', err);
    });
};
export const loadDynamicScript = (scriptId, url, callback, tagNameToAppendScript) => {
    const existingScript = document.getElementById(scriptId);
    if (!existingScript) {
        const script = document.createElement('script');
        script.src = url;
        script.id = scriptId;
        tagNameToAppendScript = tagNameToAppendScript || "body";
        document.getElementsByTagName(tagNameToAppendScript)[0].appendChild(script);
        script.onload = () => {
            if (callback)
                callback();
        };
    }
    if (existingScript && callback)
        callback();
};
export const debounce = (func, timeout = 300) => {
    let timer;
    return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => { func.apply(this, args); }, timeout);
    };
};
//# sourceMappingURL=Util.js.map